import { createRouter, createWebHistory } from 'vue-router'
import store from '../store/index.js'
import Layout from '../components/Layout.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

// 用户管理
import UserList from '../views/users/UserList.vue'
import OnboardingMonitor from '../views/users/OnboardingMonitor.vue'
import FriendGroupList from '../views/friend-groups/FriendGroupList.vue'
import HelpRepayList from '../views/friend-groups/HelpRepayList.vue'

// 邀请管理
import InvitationList from '../views/invitations/InvitationList.vue'

// 债务管理
import DebtList from '../views/debts/DebtList.vue'
import ConsumptionVerificationList from '../views/verification/ConsumptionVerificationList.vue'
import EmergencyHelpList from '../views/emergency/EmergencyHelpList.vue'

// 债中和核心功能
import TaskAllocationRules from '../views/debt-neutralization/TaskAllocationRules.vue'
import CashCardManagement from '../views/debt-neutralization/CashCardManagement.vue'
import CreditMarketManagement from '../views/debt-neutralization/CreditMarketManagement.vue'
import AllocationRecords from '../views/debt-neutralization/AllocationRecords.vue'

// 积分管理
import CreditList from '../views/credits/CreditList.vue'
import CreditTransferList from '../views/credit-transfers/CreditTransferList.vue'
import HelperCreditList from '../views/helper-credit/HelperCreditList.vue'
import WithdrawApproval from '../views/credits/WithdrawApproval.vue'
import HelperExchangeList from '../views/credits/HelperExchangeList.vue'
import TransactionList from '../views/transactions/TransactionList.vue'

// 任务管理
import TaskList from '../views/tasks/TaskList.vue'
import TaskStats from '../views/tasks/TaskStats.vue'
import PaidTasksList from '../views/paid-tasks/PaidTasksList.vue'
import PromotionTaskList from '../views/promotion/PromotionTaskList.vue'
import TaskDetail from '../views/tasks/TaskDetail.vue'

// 商户管理
import MerchantList from '../views/merchants/MerchantList.vue'
import CommissionList from '../views/commissions/CommissionList.vue'
import PaymentRecordList from '../views/payment/PaymentRecordList.vue'

// 合同管理
import ContractList from '../views/contracts/ContractList.vue'
import ContractTemplateList from '../views/contracts/ContractTemplateList.vue'

// 内容管理
import AnnouncementList from '../views/announcements/AnnouncementList.vue'
import StoriesList from '../views/stories/StoriesList.vue'
import CustomerServiceChat from '../views/customer-service/CustomerServiceChat.vue'

// 系统管理
import SystemSettings from '../views/settings/SystemSettings.vue'
import RoleList from '../views/permission/RoleList.vue'
import PermissionList from '../views/permission/PermissionList.vue'
import OperationLog from '../views/logs/OperationLog.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      // ========== 仪表盘 ==========
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '仪表盘', icon: 'Odometer', permission: '*', activeMenu: '/' }
      },
      
      // ========== 用户中心 ==========
      {
        path: 'user-center',
        name: 'UserCenter',
        meta: { title: '用户中心', icon: 'User', permission: 'user:view', group: 'user', isGroup: true },
        children: [
          {
            path: 'users',
            name: 'UserList',
            component: UserList,
            meta: { title: '用户管理', icon: 'User', permission: 'user:view' }
          },
          {
            path: 'friend-groups',
            name: 'FriendGroupList',
            component: FriendGroupList,
            meta: { title: '亲友团管理', icon: 'UserFilled', permission: 'user:view' }
          },
          {
            path: 'help-repay',
            name: 'HelpRepayList',
            component: HelpRepayList,
            meta: { title: '亲友帮还', icon: 'Money', permission: 'user:view' }
          },
          {
            path: 'invitations',
            name: 'InvitationList',
            component: InvitationList,
            meta: { title: '邀请管理', icon: 'Link', permission: 'invitation:view' }
          }
        ]
      },
      
      // ========== 债务中心 ==========
      {
        path: 'debt-center',
        name: 'DebtCenter',
        meta: { title: '债务中心', icon: 'Wallet', permission: 'debt:view', group: 'debt', isGroup: true },
        children: [
          {
            path: 'debts',
            name: 'DebtList',
            component: DebtList,
            meta: { title: '债务管理', icon: 'Money', permission: 'debt:view' }
          },
          {
            path: 'verification',
            name: 'ConsumptionVerificationList',
            component: ConsumptionVerificationList,
            meta: { title: '消费验证', icon: 'CircleCheck', permission: 'verification:view' }
          },
          {
            path: 'emergency',
            name: 'EmergencyHelpList',
            component: EmergencyHelpList,
            meta: { title: '紧急求助', icon: 'Warning', permission: 'emergency:view' }
          },
          {
            path: 'debt-neutralization',
            name: 'DebtNeutralization',
            meta: { title: '债中和', icon: 'Promotion', permission: 'debt:view' },
            children: [
              {
                path: 'allocation-records',
                name: 'AllocationRecords',
                component: AllocationRecords,
                meta: { title: '分配记录', icon: 'Document', permission: 'debt:view' }
              },
              {
                path: 'cash-card',
                name: 'CashCardManagement',
                component: CashCardManagement,
                meta: { title: '现金分卡管理', icon: 'Postcard', permission: 'debt:view' }
              },
              {
                path: 'credit-market',
                name: 'CreditMarketManagement',
                component: CreditMarketManagement,
                meta: { title: '积分市场', icon: 'Shop', permission: 'debt:view' }
              },
              {
                path: 'allocation-rules',
                name: 'TaskAllocationRules',
                component: TaskAllocationRules,
                meta: { title: '分配规则', icon: 'Setting', permission: 'debt:view' }
              }
            ]
          }
        ]
      },
      
      // ========== 积分中心 ==========
      {
        path: 'credit-center',
        name: 'CreditCenter',
        meta: { title: '积分中心', icon: 'Coin', permission: 'credit:view', group: 'credit', isGroup: true },
        children: [
          {
            path: 'list',
            name: 'CreditList',
            component: CreditList,
            meta: { title: '积分列表', icon: 'Coin', permission: 'credit:view' }
          },
          {
            path: 'transfers',
            name: 'CreditTransferList',
            component: CreditTransferList,
            meta: { title: '积分转账', icon: 'Sort', permission: 'credit:view' }
          },
          {
            path: 'helper-credit',
            name: 'HelperCreditList',
            component: HelperCreditList,
            meta: { title: '帮扶积分', icon: 'Medal', permission: 'credit:view' }
          },
          {
            path: 'helper-exchange',
            name: 'HelperExchangeList',
            component: HelperExchangeList,
            meta: { title: '兑换记录', icon: 'RefreshRight', permission: 'credit:view' }
          },
          {
            path: 'withdraw',
            name: 'WithdrawApproval',
            component: WithdrawApproval,
            meta: { title: '提现审批', icon: 'Checked', permission: 'credit:view' }
          },
          {
            path: 'transactions',
            name: 'TransactionList',
            component: TransactionList,
            meta: { title: '交易记录', icon: 'Tickets', permission: 'transaction:view' }
          }
        ]
      },
      
      // ========== 任务中心 ==========
      {
        path: 'task-center',
        name: 'TaskCenter',
        meta: { title: '任务中心', icon: 'List', permission: 'task:view', group: 'task', isGroup: true },
        children: [
          {
            path: 'list',
            name: 'TaskList',
            component: TaskList,
            meta: { title: '任务列表', icon: 'List', permission: 'task:view' }
          },
          {
            path: 'stats',
            name: 'TaskStats',
            component: TaskStats,
            meta: { title: '任务统计', icon: 'DataAnalysis', permission: 'task:view' }
          },
          {
            path: 'paid-tasks',
            name: 'PaidTasksList',
            component: PaidTasksList,
            meta: { title: '付费任务', icon: 'Money', permission: 'task:view' }
          },
          {
            path: 'promotion-tasks',
            name: 'PromotionTaskList',
            component: PromotionTaskList,
            meta: { title: '推广任务', icon: 'Promotion', permission: 'task:view' }
          }
        ]
      },
      
      // ========== 商户中心 ==========
      {
        path: 'merchant-center',
        name: 'MerchantCenter',
        meta: { title: '商户中心', icon: 'Shop', permission: 'merchant:view', group: 'merchant', isGroup: true },
        children: [
          {
            path: 'list',
            name: 'MerchantList',
            component: MerchantList,
            meta: { title: '商户管理', icon: 'Shop', permission: 'merchant:view' }
          },
          {
            path: 'commissions',
            name: 'CommissionList',
            component: CommissionList,
            meta: { title: '商户返佣', icon: 'ShoppingCart', permission: 'merchant:view' }
          },
          {
            path: 'payment',
            name: 'PaymentRecordList',
            component: PaymentRecordList,
            meta: { title: '支付记录', icon: 'Wallet', permission: 'payment:view' }
          }
        ]
      },
      
      // ========== 合同管理 ==========
      {
        path: 'contracts',
        name: 'Contracts',
        meta: { title: '合同管理', icon: 'Document', permission: 'contract:view', group: 'contract', isGroup: true },
        children: [
          {
            path: 'list',
            name: 'ContractList',
            component: ContractList,
            meta: { title: '合同列表', icon: 'Document', permission: 'contract:view' }
          },
          {
            path: 'templates',
            name: 'ContractTemplateList',
            component: ContractTemplateList,
            meta: { title: '合同模板', icon: 'Files', permission: 'contract:view' }
          }
        ]
      },
      
      // ========== 内容管理 ==========
      {
        path: 'content-center',
        name: 'ContentCenter',
        meta: { title: '内容管理', icon: 'Edit', permission: 'content:view', group: 'content', isGroup: true },
        children: [
          {
            path: 'announcements',
            name: 'AnnouncementList',
            component: AnnouncementList,
            meta: { title: '公告管理', icon: 'Bell', permission: 'content:view' }
          },
          {
            path: 'stories',
            name: 'StoriesList',
            component: StoriesList,
            meta: { title: '故事管理', icon: 'Reading', permission: 'content:view' }
          },
          {
            path: 'customer-service',
            name: 'CustomerServiceChat',
            component: CustomerServiceChat,
            meta: { title: '客服管理', icon: 'Service', permission: 'service:view' }
          }
        ]
      },
      
      // ========== 系统管理 ==========
      {
        path: 'system-center',
        name: 'SystemCenter',
        meta: { title: '系统管理', icon: 'Setting', permission: '*', group: 'system', isGroup: true },
        children: [
          {
            path: 'settings',
            name: 'SystemSettings',
            component: SystemSettings,
            meta: { title: '系统设置', icon: 'Setting', permission: '*' }
          },
          {
            path: 'roles',
            name: 'RoleList',
            component: RoleList,
            meta: { title: '角色管理', icon: 'Key', permission: '*' }
          },
          {
            path: 'permissions',
            name: 'PermissionList',
            component: PermissionList,
            meta: { title: '权限管理', icon: 'Lock', permission: '*' }
          },
          {
            path: 'logs',
            name: 'OperationLog',
            component: OperationLog,
            meta: { title: '操作日志', icon: 'Document', permission: 'log:view' }
          }
        ]
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 权限检查函数
const checkPermission = (to, store) => {
  if (to.meta.permission === '*') return true
  let permissions = []
  try {
    permissions = store.getters['auth/permissions'] || []
  } catch (error) {
    console.warn('路由守卫：无法从store获取权限:', error.message)
  }
  if (!permissions || permissions.length === 0) {
    try {
      const permissionsStr = localStorage.getItem('admin-permissions') || '[]'
      permissions = JSON.parse(permissionsStr)
    } catch (error) {
      permissions = []
    }
  }
  if (permissions.includes('*')) return true
  return permissions.includes(to.meta.permission)
}

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - 富福德正后台管理系统`
  }

  if (to.meta.requiresAuth) {
    const token = store.getters['auth/token']
    if (!token) {
      next('/login')
      return
    }
  }

  if (to.meta.permission && to.meta.permission !== '*') {
    const hasPermission = checkPermission(to, store)
    if (!hasPermission) {
      console.warn(`路由守卫：用户无权限访问 ${to.path}，但仍允许访问`)
    }
  }

  if (to.path === '/login') {
    const token = store.getters['auth/token']
    if (token) {
      next('/')
      return
    }
  }

  next()
})

export default router
